const isVimeoUrl = (url: string) => /https:\/\/watch.lesmillsondemand.com\//.test(url);

export default isVimeoUrl;
